export default __webpack_public_path__ + "static/media/presentation.aacbea4a.svg";